module.exports = __webpack_public_path__ + "../../../static/img/bs_ic_08.761bfd7a.png";